import { render, staticRenderFns } from "./addVerify.vue?vue&type=template&id=45a8a851&scoped=true&"
import script from "./addVerify.vue?vue&type=script&lang=js&"
export * from "./addVerify.vue?vue&type=script&lang=js&"
import style0 from "./addVerify.vue?vue&type=style&index=0&id=45a8a851&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a8a851",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/site-front-pipline/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45a8a851')) {
      api.createRecord('45a8a851', component.options)
    } else {
      api.reload('45a8a851', component.options)
    }
    module.hot.accept("./addVerify.vue?vue&type=template&id=45a8a851&scoped=true&", function () {
      api.rerender('45a8a851', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/PL/components/addVerify.vue"
export default component.exports